import Vue from 'vue'
import App from './App.vue'
// import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import axios from 'axios';
import './registerServiceWorker'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  created() {

    //AUTO LOGIN
    const userStr = localStorage.getItem('tenp_user');
    if (userStr) {
      const userData = JSON.parse(userStr);
      this.$store.commit('SET_USER', userData);
    }
    const tokenStr = localStorage.getItem('tenp_token');
    if (tokenStr) {
      const userToken = JSON.parse(tokenStr);
      this.$store.commit('SET_TOKEN', userToken);
    }

    axios.interceptors.response.use(
      response => response,
      error => {
        console.log(error)
        if (error.response.status === 401) {
          if (error.response.data && error.response.data.message && error.response.data.message === 'LOGIN UNAUTHORISED') {
            //do nothing
          } else {
            this.$store.dispatch('logout');
            return Promise.resolve();
          }
        }
        return Promise.reject(error);
      }
    )

  },
  render: h => h(App)
}).$mount('#app')
